<template>
  <div>
    <a-card v-if="queryList" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" v-on:keyup.enter="$refs.table.refresh(true)">
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="注意事项">
                <a-select v-model="queryParam.isMatterNeeding" allowClear="true">
                  <a-select-option value="0">有</a-select-option>
                  <a-select-option value="1">无</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :span="6">
              <a-form-item style="margin-left: 28px;" label="视频">
                <a-select v-model="queryParam.isVideo" allowClear="true">
                  <a-select-option value="0">有</a-select-option>
                  <a-select-option value="1">无</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :span="6">
              <a-form-item label="全部资料">
                <a-select v-model="queryParam.isData" allowClear="true">
                  <a-select-option value="0">有</a-select-option>
                  <a-select-option value="1">无</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :span="6">
              <a-form-item label="修改时间">
                <a-date-picker @change="onChangeTiem" style="width: 100%"  format='YYYY-MM-DD'   v-model="queryParam.updateTime"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item  label="安装类别">
                <a-select   v-model="queryParam.installType"   allowClear="true">
                  <a-select-option  v-for="type in restaurantTypes1":title="type.label" :key="type.code">{{type.label}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item style="margin-left: 28px;" label="品牌">
                <a-select
                          showSearch
                          optionFilterProp="children"
                          :filterOption="filterOption"
                          :allowClear="true"
                          v-model="queryParam.brandId" allowClear="true">
                  <a-select-option
                    :title="item.brandName" v-for="item in data4" :value="item.brandId">{{item.brandName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :span="6">
              <a-form-item style="margin-left:28px;" label="型号">
                <a-select
                          showSearch
                          optionFilterProp="children"
                          :filterOption="filterOption"
                          :allowClear="true"
                          v-model="queryParam.modelId" allowClear="true">
                  <a-select-option :title="item.modelName" v-for="item in data3" :value="item.modelId">{{item.modelName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :span="6">
              <a-form-item style="margin-left:14px;" label="修改人">
                <a-input v-model="queryParam.updateBy"/>
              </a-form-item>
            </a-col>

          </a-row>

          <a-row :gutter="24">

            <a-col :span="6">
              <a-form-item label="添加人" style="margin-left: 14px">
                <a-input v-model="queryParam.createBy"/>
              </a-form-item>
            </a-col>

            <a-col  style="text-align: right;float: right">
            <span  >
              <a-button type="primary" @click="Dataquery">查询</a-button>
              <a-button style="margin-left: 8px" @click="handClear">重置</a-button>
            </span>
            </a-col>
          </a-row>
          <a-divider/>
          <a-row style="margin-top: 10px;">
            <a-col :span="22">

            </a-col>
            <a-col :span="2" style="text-align: right">
            <span >
               <a-button value="0" v-if="addEnable" type="primary" icon="plus" @click="$refs.modal.add()">新建</a-button>
            </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator">

        <!--<a-dropdown v-if="removeEnable&&selectedRowKeys.length > 0">-->
        <!--<a-button type="danger" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button>-->
        <!--</a-dropdown>-->
      </div>
      <s-table :columns="columns"
               ref="table"
               :scroll="{ x:200 }"
               :data="loadData">
      <span slot="action" slot-scope="text, record">
        <a v-if="detailsEnable" @click="handleShow(record)">查看</a>
        <a-divider v-if="detailsEnable" type="vertical"/>
        <span v-if="editEnabel">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"/>
          <a @click="handleEdit2(record)">配置</a>
          <a-divider type="vertical" />
          <a  @click="handleEdit4(record)" v-if="record.isDisable === '0'" > 禁用</a>
          <a  @click="handleEdit4(record)" v-if="record.isDisable === '1'" > 启用</a>
        </span>
        <a-divider type="vertical" v-if="editEnabel && removeEnable" />
        <a v-if="removeEnable" @click="handleEdit3(record)">删除</a>
    </span>
      </s-table>
      <trainOverview-modal ref="modal" @ok="handleOk(arguments,userDefined)"/>

      <a-modal
        title="操作"
        style="top: 20px;"
        :width="800"
        v-model="visible"
        :confirmLoading="confirmLoading"
        @ok="handleSubmit2"
        :maskClosable="false"
      >
        <a-tree
          checkable
          @expand="onExpand"
          :expandedKeys="expandedKeys"
          :autoExpandParent="autoExpandParent"
          v-model="checkedKeys"
          @change="onChange2"
          @select="onSelect"
          :selectedKeys="selectedKeys"
          :treeData="configure"/>
      </a-modal>
    </a-card>
    <no-authority v-else></no-authority>
  </div>
</template>

<script>
import { STable } from '@/components'
import {list,list2,changeStatus,insert,getTitle,selectModelList,selectSelectionModel,modelListUpdate} from '@/api/trainOverview/trainOverview'
import {selectbrand,selectmodel} from '@/api/accessory/accessory'
import trainOverviewModal from './modules/trainOverviewModal.vue'
import NoAuthority from '../enterprise/NoAuthority'
import { checkPermission } from '@/utils/permissions'
import {getDictMap} from "../../utils/dict";
import IconText from '../list/search/components/IconText'
export default {
 name: 'TableList',
    components: {
      IconText,
      STable,
      trainOverviewModal,
      NoAuthority
    },
    data () {
      return {
        restaurantTypes1:[], // 安装类别
        // 树状图
        enterprise:'',
        autoExpandParent: true,
        checkedKeys: [],
        selectedKeys: [],
        expandedKeys: [],
        // 判断是否禁用
        isDisable:'',
        // 修改时间
        createTime: '',
        // 判断是否显示
        visible: false,
        // 配置型号
        configure: '',
        // id
        trainingMaterialsId: '',
        // 品牌列表
        data4: '',
        // 型号列表
        data3: '',
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        form: this.$form.createForm(this),
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        //表头
         columns : [
          {
            title: '操作',
            dataIndex: 'action',
            width:'20px',
            scopedSlots: { customRender: 'action' }
          },
          {
            title: '品牌',
            dataIndex: 'modelBrandList[0].brandName',
            scopedSlots: { customRender: 'modelBrandList' }
          },
          {
            title: '型号',
            dataIndex: 'modelBrandList[0].modelList[0].modelName',
            scopedSlots: { customRender: 'accessoryName' }
          },
          {
            title: '注意事项',
            dataIndex: 'isMatterNeeding'
          },
          {
            title: '视频',
            dataIndex: 'isVideo'
          },
          {
            title: '全部资料',
            dataIndex: 'isData'
          },
          {
            title: '修改人',
            dataIndex: 'updateBy'
          },
          {
            title: '修改时间',
            dataIndex: 'updateTime'
          },
          {
            title: '添加人',
            dataIndex: 'createBy'
          },
          {
            title: '添加时间',
            dataIndex: 'createTime'
          },

        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log(this.queryParam)
          return list(Object.assign(parameter, this.queryParam))
        },
        selectedRowKeys: [],
        restaurantTypes2: [],
        selectedRows: [],
        addEnable: checkPermission('train:list:add'),
        editEnabel: checkPermission('train:list:edit'),
        removeEnable: checkPermission('train:list:delete'),
        detailsEnable: checkPermission('train:list:details'),
        queryList: checkPermission('train:list:query:list'),

      }
    },
    filters: {
    },
  async  created () {

    // 查询品牌
    selectbrand().then(res => {
      console.log(res)
      this.data4 = res.rows
    })
    // 查询型号
    selectmodel().then(res => {
      console.log(res)
      this.data3 = res.rows
    })

    document.body.addEventListener('keyup', e => {
      if (e.keyCode == 13) {
        this.$refs.table.refresh(true)
      }
    })

    // 安装类别
    this.restaurantTypes1 = [];
    this.restaurantOperTypeMap1 = await getDictMap('install_type');
    this.restaurantOperTypeMap1.forEach((value, key) => {
      // console.log(value,key)
      this.restaurantTypes1.push({code: key, label: value})
    })

    },
    methods: {

      filterOption(input, option) {
        if(option){
          return (
            option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
          );
        }

      },

      handClear(){
        this.queryParam = {}
        this.createTime =''
      },


      Dataquery() {
        this.queryParam.updateTime = this.createTime
        this.$refs.table.refresh(true)
      },
      onSelect(selectedKeys, info) {
        console.log('onSelect', info);
        this.selectedKeys = selectedKeys;
      },
      onChange2(value) {
        console.log('onChange ', value);
        this.value = value;
        console.log('checked = ', checkedValues);
      },
      onExpand(expandedKeys) {
        console.log('onExpand', expandedKeys);
        this.expandedKeys = expandedKeys;
        this.autoExpandParent = true;
      },

      // 配置确定
      handleSubmit2() {

        modelListUpdate({
          'modelList': this.checkedKeys,
          'trainingMaterialsId': this.trainingMaterialsId
        }).then(res => {
          if (res.code === 0) {
            this.$message.success(res.msg)
            this.$refs.table.refresh(true)
            this.visible = false
          } else {
            this.$message.success(res.msg)
          }
        }).catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
      },

      // 删除
      handleEdit3(record) {
        this.trainingMaterialsId = record.trainingMaterialsId
        if (record.isDisable == 1) {
          this.$message.success('请先禁用')
        } else {
          this.form.validateFields(() => {
            let that = this
            this.$confirm({
              title: '删除',
              content: '您确定删除本数据吗？',
              okType: 'danger',
              onOk() {
                const changeStatus2 = {
                  trainingMaterialsId: that.trainingMaterialsId,
                  isDelete: 1
                };
                changeStatus(changeStatus2).then(res => {
                  if (res.code == 0) {
                    that.$refs.table.refresh(false)
                    // that.handleOk()
                    that.$message.success('删除成功')
                  } else {
                    that.$message.error('操作失败')
                  }
                })
              },
            });
          })
        }
      },
      // 禁用
      handleEdit4(record) {
        console.log(record)
        let that = this
        this.trainingMaterialsId = record.trainingMaterialsId
        if (record.isDisable === '0') {
          this.isDisable = 1
        } else {
          this.isDisable = 0
        }
        this.form.validateFields(() => {
          const changeStatus2 = {
            trainingMaterialsId: this.trainingMaterialsId,
            isDisable: this.isDisable
          };
          changeStatus(changeStatus2).then(res => {
            console.log(res)
            if (res.code == 0) {
              this.$message.success('操作成功')
              if(record.isDisable === '0'){
                record.isDisable = '1'
              }else{
                record.isDisable = '0'
              }
              // that.handleOk()
              // this.$emit('ok')
              // this.configure = res.data
              // this.visible = true
              console.log(this.configure)
            } else {
              this.$message.success('操作失败')
            }
          })
        })

      },

      // 修改时间
      onChangeTiem(time, timeString) {
        this.createTime = timeString

        console.log(time, timeString);
      },

      // 配置
      handleEdit2(record) {
        this.checkedKeys = []
        this.trainingMaterialsId = record.trainingMaterialsId
        list2({}).then(res => {
          if (res.code == 0) {
            this.visible = true
            selectModelList({
              'trainingMaterialsId': record.trainingMaterialsId
            }).then(data => {
              var num = 0
              for (let i = 0; i < res.data.length; i++) {
                num = 0
                for (let v = 0; v < data.data.removeModel.length; v++) {
                  for (let k = 0; k < res.data[i].children.length; k++) {
                    if (res.data[i].children[k].key == data.data.removeModel[v]) {
                      res.data[i].children[k].disableCheckbox = true;
                      num++;
                    }
                  }
                }
                if (num == res.data[i].children.length) {
                  res.data[i].disableCheckbox = true
                }
              }
              this.checkedKeys = data.data.electModel
              this.configure = res.data
            })
          } else {
            this.$message.success('操作失败')
          }
        })

      },
      // 确定
      handleSubmit() {
        this.visible = false
        insert(this.enterprise).then(res => {
          if (res.code === 0) {
            this.matterTitle = res.rows
            this.$emit('ok')
            // this.visible = false
          } else {
            this.$message.success(res.msg)
          }
        }).catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
      },

      handleAdd() {
        this.$refs.modal.add()
      },

      handleShow(record) {
        this.$refs.modal.edit(record,1)
        this.$refs.modal.query(0)
      },
      handleEdit(record) {
        this.$refs.modal.edit(record)
        this.$refs.modal.query(0)
      },

      handleOk(userDefined) {
        if (userDefined != undefined && userDefined.length != 0) {
          const record = {
            trainingMaterialsId:userDefined[0]
          }
          this.$refs.modal.edit(record)
        } else {
          this.$refs.table.refresh(true)
        }
      }
    },
    watch: {
      checkedKeys(val) {
        this.enterprise = val;

        //this.delByIds = val;
      },
      /*
        'selectedRows': function (selectedRows) {
          this.needTotalList = this.needTotalList.map(item => {
            return {
              ...item,
              total: selectedRows.reduce( (sum, val) => {
                return sum + val[item.dataIndex]
              }, 0)
            }
          })
        }
        */
    }
  }

</script>
<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; }
  /deep/ .ant-table td {  padding: 4px 16px;}
</style>